import { pickInstanceIdFromAuthUser, pickUserIdFromAuthUser, readPersistedSessionIds } from './sessionIds';
import {
    emptyUserInstancePrefs,
    mergeUserInstancePrefsPatch,
    readUserInstancePrefsDoc,
} from './userInstancePrefs';

/**
 * @param {unknown} blob
 * @returns {{ places_ids: string[] }}
 */
export function normalizeScreeningsFiltersUi(blob) {
    if (!blob || typeof blob !== 'object') {
        return { places_ids: [] };
    }
    const places_ids = Array.isArray(blob.places_ids)
        ? blob.places_ids.map((x) => String(x)).filter(Boolean)
        : [];
    return { places_ids };
}

/** @returns {{ places_ids: string[] }} */
export function readPersistedScreeningsFiltersUi() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return { places_ids: [] };
    }
    try {
        const { userId, instanceId } = readPersistedSessionIds();
        if (!userId) {
            return { places_ids: [] };
        }
        const doc = readUserInstancePrefsDoc(userId, instanceId) || emptyUserInstancePrefs();
        return normalizeScreeningsFiltersUi(doc.screeningsFiltersUi);
    } catch (_e) {
        return { places_ids: [] };
    }
}

/**
 * @param {string|null|undefined} userId
 * @param {string|null|undefined} instanceId
 * @param {{ places_ids?: unknown }} filters
 */
export function persistScreeningsFiltersUi(userId, instanceId, filters) {
    if (!userId) {
        return;
    }
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }
    try {
        mergeUserInstancePrefsPatch(userId, instanceId || 'none', {
            screeningsFiltersUi: normalizeScreeningsFiltersUi(filters),
        });
    } catch (_e) {
        /* ignore */
    }
}

/**
 * @param {object|null|undefined} authUser
 * @returns {{ userId: string|null, instanceId: string }}
 */
export function resolveScreeningsFiltersSession(authUser) {
    return {
        userId: pickUserIdFromAuthUser(authUser) || readPersistedSessionIds().userId,
        instanceId: pickInstanceIdFromAuthUser(authUser) || readPersistedSessionIds().instanceId || 'none',
    };
}
